import type {ComponentType} from 'react'
import Wrapper from '@freckle/school/ts/common/routers/wrapper'
import type {ConfigurableWrapperProps as WrapperProps} from '@freckle/school/ts/common/routers/wrapper'

type Props = {
  component: ComponentType<object>
  wrapperParams?: WrapperProps
  fullScreen?: boolean
}

export default function LoggedRoute(props: Props) {
  const {wrapperParams, component: Component, fullScreen} = props

  return (
    <Wrapper {...(wrapperParams as NonNullable<WrapperProps>)} fullScreen={fullScreen}>
      <Component />
    </Wrapper>
  )
}
